import { CustomerManageForm } from "features/account"

const CustomersManage = () => {
  return (<CustomerManageForm/>)
}

export default CustomersManage